import { AccountingErrorCode, AccountingErrorResponse } from 'multirpc-sdk';
import { AxiosError } from 'axios';

import { getAccountingErrorCode } from 'store/utils/getAccountingErrorCode';
import { isAxiosAccountingError } from 'store/utils/isAxiosAccountingError';

export const isEmptyEthAddressAuthError = (
  error: unknown,
): error is AxiosError<AccountingErrorResponse> =>
  isAxiosAccountingError(error) &&
  getAccountingErrorCode(error) === AccountingErrorCode.FailedPrecondition;
